import { Box, Card, CardContent, CardHeader, Typography, Stack } from '@mui/material';

import { DefaultScreenImageUploadField } from '../default-screen-image-upload-field.component';
import { DEFAULT_SCREEN_IMAGES_SECTION_TITLE } from '../../touchpoint.constants';

export const DefaultScreenImagesSection = () => {
  return (
    <Box mb={2}>
      <Card>
        <CardHeader
          title={
            <Typography variant='subtitle1' paragraph>
              {DEFAULT_SCREEN_IMAGES_SECTION_TITLE}
            </Typography>
          }
        />
        <CardContent>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 4, sm: 0 }}
            justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            flexWrap='wrap'
          >
            <DefaultScreenImageUploadField
              aspectRatio='4x3'
              imageFieldName='landscapeImage'
              urlFieldName='landscapeImageUrl'
            />
            <DefaultScreenImageUploadField
              aspectRatio='1x1'
              imageFieldName='squareImage'
              urlFieldName='squareImageUrl'
            />
            <DefaultScreenImageUploadField
              aspectRatio='9x16'
              imageFieldName='portraitImage'
              urlFieldName='portraitImageUrl'
            />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};
